import * as React from 'reactn';
import {
    ArrayUtil,
    BaseIcon, ComponentFactory,
    dialog,
    IBaseDialogProps
} from "oca-lib-web";
import Styles from "../style/Styles";

interface IState {
    componentFactory:ComponentFactory
}

/* Main dialog for selection different graphs */
class ReportSettingsDialog extends React.Component<IBaseDialogProps, IState> {

    constructor(props: any) {
        super();

        let componentFactory = new ComponentFactory(Styles.default);
        componentFactory.addDefaultBinding(null, null, props.param);
        console.log("props params");
        console.log(props.param);

        this.state = {
            componentFactory:componentFactory
        };

        props.dialog.saveFunction(this.handleSave.bind(this));
    }

    async handleSave(callback:any) {
        let componentBinding = this.state.componentFactory.getDefaultBinding();
        console.log(componentBinding.item);

        callback(componentBinding.item);
    }

    moveGraph(item:PageSettings, direction:string) {
        let componentBinding = this.state.componentFactory.getDefaultBinding();

        //let reportSettings = this.state.reportSettings;
        let reportSettings = componentBinding.item;
        let indexOf = reportSettings.pages.indexOf(item);
        if ((indexOf == 0 && (direction == "up" || direction == "first")) || (indexOf == reportSettings.pages.length - 1 && (direction == "down" || direction == "last"))) {
            return;
        }

        indexOf = direction == "first" ? 0 : direction == "up" ? indexOf - 1 : direction == "down"  ? indexOf + 1 : direction == "last" ? reportSettings.pages.length - 1 : 0;
        ArrayUtil.deleteItem(item, reportSettings.pages);
        reportSettings.pages.splice(indexOf, 0, item);

        this.forceUpdate();

        /*this.setState({reportSettings:reportSettings}, function(this:ReportSettingsDialog) {
            this.forceUpdate();
        }.bind(this));*/
    }

    async deletePageSetting(item:any) {
        let componentBinding = this.state.componentFactory.getDefaultBinding();
        let reportSettings = componentBinding.item;
        ArrayUtil.deleteItem(item, reportSettings.pages);

        this.forceUpdate();

        /*this.setState({reportSettings:reportSettings}, function(this:ReportSettingsDialog) {
            this.forceUpdate();
        }.bind(this));*/
    }

    renderPageSetting(item:PageSettings) {
        const cf = this.state.componentFactory;
        const actionLink = [
            cf.renderIconButton(BaseIcon.ICON_FIRST_PAGE, () => this.moveGraph(item, "first"), "Move to Front", {color:"primary"}),
            cf.renderIconButton(BaseIcon.ICON_KEYBOARD_ARROW_UP, () => this.moveGraph(item, "up"), "Move Up", {color:"primary"}),
            cf.renderIconButton(BaseIcon.ICON_KEYBOARD_ARROW_DOWN, () => this.moveGraph(item, "down"), "Move Down", {color:"primary"}),
            cf.renderIconButton(BaseIcon.ICON_LAST_PAGE, () => this.moveGraph(item, "last"), "Move to Back", {color:"primary"}),
            cf.renderIconButton(BaseIcon.ICON_DELETE,
                () => this.props.dialog.alert("Confirm Delete", "Are you sure you want to delete this graph? This action cannot be undone.", this.deletePageSetting.bind(this), item), "Delete", {color:"secondary"}),
        ]

        return [
            item.pageTitle,
            actionLink
        ]
    }

    public render() {
        const cf = this.state.componentFactory;
        let componentBinding = this.state.componentFactory.getDefaultBinding();

        return (
            cf.renderBox([
                cf.renderBoxPadded(cf.renderTextField("reportTitle", "Report Title")),
                cf.renderBoxPadded(cf.renderTextField("primaryColor", "Primary Color")),
                cf.renderBoxPadded(cf.renderTable(["Page Title", ""], componentBinding.getProperty("pages"), this.renderPageSetting.bind(this)))
            ])
        )
    }
}

export default dialog(ReportSettingsDialog)